<template>
  <div class="header">
    <img src="/img/logo_blanco.png" alt="El Capricho" height="60">
  </div>
</template>

<script>
export default {
  name: 'HeaderComponent',

}
</script>


<style scoped> 
    .header{
        width: 100%;
        height: 60px;
        background-color: #2B282C;
        position: absolute;
        z-index: 1;
        top:0;
        text-align: center;
    }
</style>
